/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/modules/es6.promise.js";

import React from 'react'
import ReactDOM from 'react-dom';
import qs from 'qs';
import { createBrowserHistory } from 'history';

import {observable, computed, action} from 'mobx';
import {observer} from "mobx-react";

import TagFilters from "../components/TagFilters";

import algoliasearch from 'algoliasearch/lite';
import {InstantSearch, Hits, Configure, Index} from 'react-instantsearch-dom';
import Snippet from '../components/MySnippet';
import Dropdown from "../components/Dropdown";
import TopSearch from "../components/TopSearch";
import SearchResults from "../components/SearchResults";
import SearchWithin from "../components/SearchWithin";
import AreaFilter from "../components/AreaFilter";

const _ = require('lodash');
const _get = require('lodash/get');
const _sortBy = require('lodash/sortBy');
const _debounce = require('lodash/debounce');

const history = createBrowserHistory();

import {
  BrowserView,
  MobileView,
  isMobile,
} from "react-device-detect";
import Tag from "../components/Tag";
import {addRecent, RecentView} from "../components/Recent";
import Stats from "../components/Stats";
import {Button} from "../components/Button";
import Level from "../components/Level";
import {Modal} from "../components/Modal";
import {Share} from "../components/Share";
import I18n from "../I18n";
import CategoryFilter from "../components/CategoryFilter";
import {Pic} from "../components/ImgStore";
var Mark = require('mark.js');

const searchClient = algoliasearch('OKPQ394LEA', '029a628a8e97effbac7ed51773fd0622');

class AppState {
  @observable post = gon.post;
  @observable markWords = true;
  @observable search = {};
  @observable showFilters = null;
  @observable searchingRelated = false;
  @observable tagSearching = false;
  @observable showRecent = false;
  @observable related = false;

  clearFilters = () => {
    let search = {...state.search};

    delete search.refinementList.tags;
    delete search.refinementList.category;
    delete search.refinementList.areas;

    this.setSearch(search);
  };

  setSearch = (searchState, redirect) => {
    state.search = searchState;

    let params = {};

    if (searchState.page > 1)
      params.page = searchState.page ;

    if (searchState.query && searchState.query.length)
      params.query = searchState.query;

    rlist(searchState, params, 'tags');
    rlist(searchState, params, 'category');
    rlist(searchState, params, 'areas');

    state.post = null;
    if ((state.post && !isMobile) || redirect) {
      // only applicable to old top search
      // location.href = "/?" + qs.stringify(params);
    }
    // else
      historySet(params);
  };

  @computed get filtersNum() {
    let n=0;
    for(let k of ['tags', 'category', 'areas']) {
      let vals = _get(this.search, 'refinementList.' + k);
      if (vals)
        n += vals.length;
    }

    return n;
  }

  findRelated = async () => {
    state.searchingRelated = true;

    baseFindRelated(tags => {
      if (tags)
        state.setSearch({refinementList: {tags}}, true);
      else {
        state.searchingRelated = false;
        alert(I18n.search.noResults);
      }
    });
  }
}
let state = new AppState();

const baseFindRelated = async (onFound) => {
  let index = searchClient.initIndex(gon.indexPrefix + "_posts");

  let pick = (rest, prev) => {
    let next = rest.shift();

    if (!next) {
      onFound(prev);
      return;
    }

    let current = prev.concat(next);

    index.search({
        facetFilters: current.map(t => "tags:" + t),
      },
      function searchDone(err, content) {
        if (err) throw err;

        if (content.nbHits < 2)
          onFound(prev);
        else {
          pick(rest, current);
        }
      }
    );
  };

  let tags = state.post.tags.filter(t => t !== "Legal Questions" && t !== "Legal Definitions" && t !== "legal doctrines");
  let result = await Promise.all(tags.map(tag => index.search({
    facetFilters: ["tags:" + tag], // OR query
    facets: "tags",
  })));

  let counts = tags.map((t, i) => [t, result[i].nbHits]);
  let ordered = _sortBy(counts, t => t[1] * 1000 + t[0].charCodeAt(0)).filter(t => t[1] > 1).map(t => t[0]);

  if (ordered.length < 1)
    onFound();
  else
    pick(ordered, []);
};


if (state.post) {
  baseFindRelated(tags => {
    if (tags) {
      let index = searchClient.initIndex(gon.indexPrefix + "_posts");
      index.search({
          facetFilters: tags.map(t => "tags:" + t),
        },
        function searchDone(err, content) {
          state.related = _.slice(_.reject(content.hits, { id: state.post.id }), 0, 10);
        });
    }
  })
}


var store = require('store');

const historySet = _debounce(params => history.push("/" + "?" + qs.stringify(params), params), 500);

function rlist(search, params, k) {
  let vals = _get(search, 'refinementList.' + k);

  if (vals)
    params[k] = vals.join("~").replace(/ /g, "_");
}

let urlToSearchState = () => {
  const routeState = qs.parse(location.search.slice(1));
  let search = {
    refinementList: {},
    page: routeState.page || 1
  };

  if (routeState.query)
    search.query = routeState.query;

  if (routeState.tags)
    search.refinementList.tags = routeState.tags.replace(/_/g, " ").split('~');

  if (routeState.category)
    search.refinementList.category = routeState.category.replace(/_/g, " ").split('~');

  if (routeState.areas)
    search.refinementList.areas = routeState.areas.replace(/_/g, " ").split('~');

  state.search = search;
};
urlToSearchState();

history.listen((location, action) => {
  urlToSearchState();
});



if (store.get('lastSearch')) {
  state.search = store.get('lastSearch');

  store.remove('lastSearch')
}

function clickPostTitle(e, hit) {
  store.set('lastSearch', state.search);
  addRecent('posts', hit.title, "/" + hit.url);
  e.preventDefault();

  window.location = "/" + hit.url;
}

const Hit = ({hit}) => {
  let img = hit.title.length > 0 ? <Pic css={'is-4by3'} type='list' post={hit} /> : null;

  let onClick = e => clickPostTitle(e, hit);

  return <div className="search-post">
    <BrowserView>
      <article className="media">
        {img && <div className="media-right" style={{width: "33%"}} onClick={onClick}>{img}</div>}

        <div className="media-content has-text-right">
          <h1 className="post-title">
            <a href={"/" + hit.url} onClick={onClick}>{hit.title}</a>
          </h1>
          <Snippet hit={hit} attribute="body"/>
        </div>
      </article>
    </BrowserView>
    <MobileView>
      <div style={{display: 'flex'}}>
        <div onClick={onClick} style={{flex: 1, paddingLeft: '0.5rem', paddingTop: '0.5rem'}}>{img}</div>
        <h1 className="post-title" style={{flex: 3}}>
          <a href={"/" + hit.url} onClick={onClick}>{hit.title}</a>
        </h1>
      </div>
      <Snippet hit={hit} attribute="body"/>
    </MobileView>
  </div>;
};

@observer
class FiltersModalButton extends React.Component {
  onClick = () => {
    state.showFilters = this.props.sym;
  };

  render() {
    let {title, sym} = this.props;

    let tag = state.search.refinementList && state.search.refinementList[sym];
    tag = tag && tag.length;

    return <li className={state.showFilters === sym ? "is-active" : ""} onClick={this.onClick}>
      <a className="badge is-badge-danger">
        <span>{title}</span>
        {tag && <span className="tag">{tag}</span> }
      </a>
    </li>
  }
}


@observer
class RecentModal extends React.Component {
  close = () => state.showRecent = false;

  render() {
    if (!state.showRecent)
      return null;

    return <Modal onClose={this.close}>
      <RecentView sym="posts" title={I18n.recent.posts} />
    </Modal>
  }
}

@observer
class FiltersModal extends React.Component {
  tagFocus = () => state.tagSearching = true;
  tagBlur = () => state.tagSearching = false;

  close = () => {
    if (state.post && isMobile)
      location.reload();
    else
      state.showFilters = null;
  };

  footer() {
    if (state.tagSearching)
      return;

    return <footer className="modal-card-foot">
      <div style={{flexGrow: 1}} />
      <button className="button is-success" onClick={this.close}>{I18n.filters.done}</button>
    </footer>
  }

  render() {
    return <div className={`modal modal-full-screen filters-modal ${state.showFilters && "is-active"}`}>
      <div className="modal-background"/>
      <div className="modal-card">
        <header className="modal-card-head">
          <div style={{flex: 1}}>
            <div className="modal-card-title">
              <Level className="level is-mobile">
                <Stats/>
                <Button title={I18n.filters.clear} css="is-link is-inverted" onClick={state.clearFilters}/>
              </Level>
            </div>
            <div className="tabs is-toggle is-fullwidth">
              <ul>
                <FiltersModalButton title={I18n.tags.title}  sym="tags"/>
                <FiltersModalButton title={I18n.filters.areas} sym="areas"/>
                <FiltersModalButton title={I18n.filters.category}  sym="category"/>
              </ul>
            </div>
          </div>
        </header>
        <section className={"modal-content show-" + state.showFilters}>
          <TagFilters attribute="tags" operator="and" limit={51} hidden={state.showFilters !== "tags"} searchable={true} placeholder={I18n.tags.findMore}
                      searchProps={{
                        onFocus: this.tagFocus,
                        onBlur: this.tagBlur
                      }}
          />
          <CategoryFilter hidden={state.showFilters !== "category"}/>
          <AreaFilter hidden={state.showFilters !== "areas"}/>
        </section>
        {this.footer()}
      </div>
    </div>
  }
}


class Menu extends React.Component {
  render() {
    let props = {};
    if (isMobile)
      props.icon = "menu";
    else {
      props.down = true;
      props.title = I18n.menu.title;
    }

    let items = gon.menu.map(m => ({title: m.linkName, href: "/" + m.link}));

    if (isMobile)
      items.push({title: I18n.recent.posts, onClick: () => state.showRecent = true});

    return <div>
      <RecentModal />
      <Dropdown {...props} items={items} />
    </div>
  }
}

class PostTag extends React.Component {
  @action
  onClick = () => {
    let {tag} = this.props;

    location.href = "/?tags=" + tag;
  };

  render() {
    let {tag} = this.props;

    return <Tag name={tag} key={tag}/>
  }
}

const PostArea = ({name}) => <a href={"/?areas=" + name.replace(/ /g, "_")} className={"tag is-info"}>{name}</a>;

@observer
class Post extends React.Component {
  componentDidMount() {
    this.componentDidUpdate();
  }

  expandRegexp(tags, exact) {
    let ignore = "[.'\"`,]*";
    let compress = "[\\n\\r\\\\t&;:()\\[\\]\\/\\- ]+";

    let regexp = tags.map(t => t.split("").join(ignore).split(/ /).join(compress)).join("|");

    if (exact)
      regexp = `(^|\\W)(${regexp})(\\W|$)`;

    return new RegExp(regexp, "i");
  }

  componentDidUpdate() {
    let marker = new Mark("div.post-body");

    if (!this.props.markWords) {
      marker.unmark();
      return;
    }

    let opts = {
      ignorePunctuation: ".'\"`,".split(""),
      separateWordSearch: false,
    };

    let [exact, fuzzy, query] = this.markWords();

    if (query.length)
      marker.mark(query, {className: 'query-mark', ...opts});

    if (fuzzy.length)
      marker.markRegExp(this.expandRegexp(fuzzy), opts);

    if (exact.length)
      marker.markRegExp(this.expandRegexp(exact, true), {accuracy: 'exactly', ...opts});

  }

  markWords() {
    if (!state.post)
      return [[], []];

    if (this.toMark)
      return this.toMark;

    let query = _get(state, "search.query");
    let tags = new Set(_get(state, "search.refinementList.tags"));

    let selectedTags = _.filter(gon.tags, t => tags.has(t.name));

    let exact = _.flatMap(selectedTags, 'exact');
    let fuzzy = _.flatMap(selectedTags, 'fuzzy');

    this.toMark = [exact, fuzzy, query ? query.split(/ /) : []];

    return this.toMark
  }

  toggleMarkWords = () => {
    state.markWords = !state.markWords;
  };

  renderSwitch() {
    if (!this.markWords())
      return null;

    return <div className="field highlight-switch" onClick={this.toggleMarkWords}>
      <input type="checkbox" className="switch" checked={state.markWords} onChange={this.toggleMarkWords}/>
      <label htmlFor="switchExample">{I18n.post.markText}</label>
    </div>;
  }

  render() {
    let {hit} = this.props;

    let lines = hit.body.replace(/<[^a]+?>/g, '').replace(/##(.+?)##/g, (a, s) => `<b>${s}</b>`).split(/[\r\n]\s*/).map((line, i) => <p key={i} dangerouslySetInnerHTML={{__html: line}}></p>);

    let picAfter = isMobile ? 2 : 4;
    lines.splice(picAfter, 0, <Pic css='post' post={gon.post} key="pic" />);

    return <div className="search-post">
      <Level>
        <h2 className="post-title">
          {hit.title}
          {gon.admin && <a href={`/posts/${gon.post.id}/edit`}>edit</a>}
        </h2>
        { !isMobile && this.renderSwitch()}
      </Level>
      <Level className="level is-mobile">
        <a className="button is-success" href="/contact">{_.find(gon.menu, {link: "contact"}).title}</a>
        { isMobile ? this.renderSwitch() : <FindRelatedBtn /> }
      </Level>
      <div className="post-body">
        {lines}
      </div>
      <br />
      <Level>
        <a className="button is-success" href="/contact">{I18n.menu.contact2}</a>
        <FindRelatedBtn />
      </Level>
      { state.related &&
      <>
        <br />
        <b>{I18n.post.related}</b>
        <br />
        <br />
        {state.related.map(post => <Hit hit={post} />)}
      </>
      }
      <br />
      <div className="tags">
        {hit.tags.map(t => <PostTag tag={t} key={t} />)}
      </div>
      <div className="tags">
        {hit.areas.map(area => <PostArea name={area} key={area} />)}
      </div>
      <Share />
    </div>;
  }
}

const FindRelatedBtn = ({css}) => <Button css={css || "is-primary is-danger"} title={I18n.post.findRelated} onClick={state.findRelated} loading={state.searchingRelated}/>;

@observer
class TopSearch2 extends React.Component {
  render() {
    let search = gon.sitePage ? <TopSearch /> : <SearchWithin/>;

    return <InstantSearch searchClient={searchClient}
                          searchState={state.search}
                          onSearchStateChange={state.setSearch}
                          indexName={gon.indexPrefix + "_posts"}>
      {search}
    </InstantSearch>
  }
}

@observer
class Main extends React.Component {
  searchArea() {
    return <>
      {/*need to keep it here for the search to work above?? hiding it :( */}
      <div style={{display: "none"}}><SearchWithin/></div>

      <div className="results">
        <Stats/>
        <Hits hitComponent={Hit}/>
        <SearchResults/>
      </div>
    </>
  }

  postArea() {
    return <Post hit={state.post} markWords={state.markWords}/>
  }

  inner() {
    if (state.post)
      return this.postArea();
    else
      return this.searchArea();
  }

  mobileBtns() {
    if (state.post)
        return <>
          <button className="button mobile-filter-button is-info is-fullwidth badge is-badge-danger" data-badge={state.filtersNum || null}
                  onClick={() => state.showFilters = "tags"}>
            {I18n.filters.title}
          </button>
          <FindRelatedBtn css="button mobile-filter-button is-danger"/>
        </>;
      else
        return <button className="button is-info is-large is-fullwidth badge is-badge-danger" data-badge={state.filtersNum || null}
                                     onClick={() => state.showFilters = "tags"}>
          {I18n.filters.title}
        </button>

  }

  render() {
    let tagsTitle = state.filtersNum > 0 || state.search.query ? I18n.tags.title : I18n.tags.popular ;

    return <InstantSearch searchClient={searchClient}
                          searchState={state.search}
                          onSearchStateChange={state.setSearch}
                          indexName={gon.indexPrefix + "_posts"}>
      <Configure
        hitsPerPage={isMobile ? 4 : 10}
        attributesToSnippet={[`body:${isMobile ? 16 : 50}`]}
      />
      <div className="columns is-variable is-4">
        <div className="column is-3">
          <BrowserView>
            <div className="box">
              <Level>
                <div className="subtitle has-text-grey">{I18n.filters.title}</div>
                <Button title={I18n.filters.clear} css="is-link is-inverted" onClick={state.clearFilters}/>
              </Level>
              <CategoryFilter />
              <br/>
              <AreaFilter/>
            </div>
            <div className="recent-box">
              <RecentView sym="posts" title={I18n.recent.posts} />
              <br />
              <RecentView sym="searches" title={I18n.recent.searches} />
            </div>
          </BrowserView>
          <MobileView>
            {this.mobileBtns()}
            <FiltersModal/>
          </MobileView>
        </div>
        <div className="column is-6">
          {this.inner()}
        </div>
        <div className="column is-3">
          <BrowserView>
            <div className="box">
              <TagFilters attribute="tags" operator="and" limit={51} title={tagsTitle} searchable={true} placeholder={I18n.tags.findMore}/>
            </div>
          </BrowserView>
        </div>
      </div>
    </InstantSearch>
  }
}

function activate(id, component) {
  let div = document.getElementById(id);

  if (div)
    ReactDOM.render(component, div);
}

setTimeout(() => {
  activate('top-search', <TopSearch2/>);
  activate('menu', <Menu/>);
  activate('app', <Main/>);
}, 0);
